import { useEffect, useRef } from "react"

const isYoutubeUrl = (url) => {
    return url && (url.includes("youtube.com") || url.includes("youtu.be"));
};

const getYoutubeEmbedUrl = (url) => {
    if (!url) return "";
    if (url.includes("/embed/")) return url;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
        return `https://www.youtube.com/embed/${match[2]}?autoplay=1&rel=0`;
    }
    return url;
};

export const CoursePreviewModal = ({ selectedEpisode, episodesData, onClose, onSelectEpisode }) => {
    const videoRef = useRef(null)

    // Disable body scroll on mount and restore on unmount
    useEffect(() => {
        document.body.style.overflow = "hidden"
        return () => {
            document.body.style.overflow = "unset"
        }
    }, [])

    // Explicitly play video when episode changes to bypass browser video start blocks
    useEffect(() => {
        if (selectedEpisode && videoRef.current) {
            videoRef.current.load()
            const playPromise = videoRef.current.play()
            if (playPromise !== undefined) {
                playPromise.catch(error => {
                    console.log("Autoplay check failed:", error)
                })
            }
        }
    }, [selectedEpisode])

    if (!selectedEpisode) return null

    return (
        <div
            className="modal show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.85)", zIndex: 9999999 }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                role="document"
                style={{ maxWidth: "680px" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="modal-content"
                    style={{ background: "#0e2231", color: "#ffffff", borderRadius: "12px", overflow: "hidden", border: "1px solid rgba(255, 255, 255, 0.1)" }}
                >
                    {/* Modal Header */}
                    <div
                        className="modal-header d-flex justify-content-between align-items-start"
                        style={{ padding: "18px 24px", borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}
                    >
                        <div>
                            <span
                                className="preview-subtitle text-uppercase d-block"
                                style={{ fontSize: "12px", color: "var(--gold-light)", letterSpacing: "0.1em", fontWeight: 500, marginBottom: "4px" }}
                            >
                                Course Preview
                            </span>
                            <h5
                                className="modal-title m-0 text-white"
                                style={{ fontSize: "18px", fontWeight: "600", lineHeight: 1.3 }}
                            >
                                {selectedEpisode.title}
                            </h5>
                        </div>
                        <button
                            type="button"
                            className="preview-close-btn"
                            onClick={onClose}
                            aria-label="Close"
                            style={{ background: "none", border: "none", color: "#ffffff", fontSize: "20px", opacity: 1, cursor: "pointer" }}
                        >
                            <i className="fas fa-times" style={{ color: "#ffffff" }}></i>
                        </button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body p-0">
                        <div
                            className="preview-video-wrapper"
                            style={{ background: "#000000", width: "100%", aspectRatio: "16 / 9" }}
                        >
                            {isYoutubeUrl(selectedEpisode.videoUrl) ? (
                                <iframe
                                    key={selectedEpisode.num}
                                    src={getYoutubeEmbedUrl(selectedEpisode.videoUrl)}
                                    title={selectedEpisode.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                    className="preview-video-player"
                                    style={{ width: "100%", height: "100%", display: "block", border: "none" }}
                                />
                            ) : (
                                <video
                                    ref={videoRef}
                                    key={selectedEpisode.num}
                                    src={selectedEpisode.videoUrl}
                                    controls
                                    autoPlay
                                    playsInline
                                    className="preview-video-player"
                                    style={{ width: "100%", height: "100%", display: "block" }}
                                />
                            )}
                        </div>

                        {/* <div className="preview-playlist-section">
                            <h4 className="playlist-heading">Free Sample Videos:</h4>
                            <div className="playlist-items-container">
                                {episodesData.map((episode) => (
                                    <div
                                        key={episode.num}
                                        className={`playlist-item ${selectedEpisode.num === episode.num ? 'active' : ''}`}
                                        onClick={() => onSelectEpisode(episode)}
                                    >
                                        <div className="playlist-item-left">
                                            <div className="playlist-thumbnail">
                                                {selectedEpisode.num === episode.num ? (
                                                    <i className="fas fa-volume-up active-icon"></i>
                                                ) : (
                                                    <i className="fas fa-play play-icon"></i>
                                                )}
                                            </div>
                                            <div className="playlist-item-details">
                                                <span className="playlist-item-num">Episode {episode.num}</span>
                                                <span className="playlist-item-title">{episode.title}</span>
                                            </div>
                                        </div>
                                        <span className="playlist-item-duration">{episode.duration}</span>
                                    </div>
                                ))}
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
